import {useState} from "react";
import {
    Box, Button, ButtonGroup, Card, CardContent, Checkbox,
    FormControl, FormControlLabel,
    IconButton,
    InputLabel,
    MenuItem,
    Modal,
    OutlinedInput,
    Select,
    TextField, Tooltip,
    Typography
} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import InfoIcon from '@mui/icons-material/Info';
import AddCircleIcon from "@mui/icons-material/AddCircle";
import PropTypes from "prop-types";
import {DateTimePicker} from "@mui/lab";
import LoadingBackdrop from "../../../components/LoadingBackdrop";
import {dateRangesOverlap} from "../../../utils/basicUtilities";

const modalStyle = {
    position: 'absolute',
    top: '25%',
    left: '50%',
    transform: 'translate(-50%, -25%)',
    // width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

/**
 * Component for managing suppression lists
 * @param props
 * @constructor
 */
export default function QuotaModal(props) {
    const defaultValues = {
        startDate: new Date(Date.now()),
        endDate: new Date(Date.now() + 10000000),
        "impressionMinQuota": "any", "impressionMinQuotaBias": 0,
        "clickMinQuota": "any", "clickMinQuotaBias": 0,
        "clickMaxQuota": "any",
        "salesMinQuota": "any", "salesMinQuotaBias": 0,


        "impressionMaxQuota": "any",
        "saleMaxQuota": "any",
    };
    const dtFormat = {year: 'numeric', month: 'numeric', day: 'numeric', timeZone: 'America/New_York' };
    const quotas = props.quotas ? props.quotas : [];
    const quotaElements = [];
    for (let i = 0; i < quotas.length; i += 1) {
        const indexCnt = i;
        quotaElements.push(<span style={{"display": "flex"}} key={`quota${i}`}>
            <Card>
                <span style={{"float":"right"}}>
                    <IconButton aria-label="delete" onClick={() => {
                        setEditingQuotaObj({...quotas[i]});
                        setEditingQuotaObjIndex(i);
                    }}>
                      <EditIcon/>
                    </IconButton>
                    <IconButton aria-label="delete" onClick={() => {
                        console.log(indexCnt);
                        const supp = [...quotas];
                        supp.splice(indexCnt, 1);
                        props.setQuotas(supp)
                    }}>
                      <DeleteIcon/>
                    </IconButton>
                </span>
                <br/>
              <CardContent>
                <Typography  color="text.secondary" gutterBottom>
                  From: {quotas[i].startDate.toLocaleString('en-US', dtFormat)}
                  <br/>To: {quotas[i].endDate.toLocaleString('en-US', dtFormat)}
                </Typography>
                <Typography sx={{ mb: 1.5 }} color="text.secondary">
                  Min Clicks: {quotas[i].clickMinQuota}, Bias: ${parseFloat(quotas[i].clickMinQuotaBias).toFixed(4)}
                  <br/>
                  Max Clicks: {quotas[i].clickMaxQuota}
                </Typography>
              </CardContent>
            </Card>

           </span>)
        quotaElements.push(<br key={`br${i}of-quota`}/>);
    }
    // const [startDate, setStartDate] = useState(new Date(Date.now()));
    // const [endDate, setEndDate] = useState(new Date(Date.now()));
    const [editingQuotaObj, setEditingQuotaObj] = useState(null);
    const [editingQuotaObjIndex, setEditingQuotaObjIndex] = useState(null);

    const elementsForEditor = [];

    if (editingQuotaObj != null) {
        // eslint-disable-next-line no-restricted-syntax
        for (const z of ["click"]) {

            console.log(editingQuotaObj[`${z}MinQuota`] === "any");
            const minQ = `${z}MinQuota`;
            const maxQ = `${z}MaxQuota`;
            const minQBias = `${z}MinQuotaBias`;
            elementsForEditor.push(<div key={z}>
                <Typography align="left" style={{"marginTop": "auto", "marginBottom": "auto"}}>
                    Click Quotas:
                </Typography>
                <br/>
                <TextField
                    id={`min-${z}-quota`}
                    label={`Min ${z} Quota`}
                    value={editingQuotaObj[`${z}MinQuota`]}
                    disabled={editingQuotaObj[`${z}MinQuota`] === "any"}
                    inputProps={{inputMode: 'numeric', pattern: '[0-9]*'}}
                    onChange={(v) => {
                        const objCopy = {...editingQuotaObj};
                        objCopy[minQ] = parseInt(v.target.value, 10);
                        setEditingQuotaObj(objCopy);
                    }}
                />

                &nbsp;&nbsp;&nbsp;
                <TextField
                    id={`min-${z}-bias`}
                    label={`Min ${z} Quota Bias`}
                    value={editingQuotaObj[`${z}MinQuotaBias`]}
                    disabled={editingQuotaObj[`${z}MinQuota`] === "any"}
                    error={Number.isNaN(parseFloat(editingQuotaObj[`${z}MinQuotaBias`]))}
                    onChange={(v) => {
                        const objCopy = {...editingQuotaObj};
                        objCopy[minQBias] = v.target.value;
                        setEditingQuotaObj(objCopy);
                    }}
                />
                <Tooltip style={{"marginTop": ".25em"}}
                         title={`Bias Is Maximum Expected Loss In Cents Per ${z.toUpperCase()}`}>
                    <IconButton>
                        <InfoIcon/>
                    </IconButton>
                </Tooltip>

                <FormControlLabel style={{"margin": "auto"}} control={
                    <Checkbox checked={editingQuotaObj[`${z}MinQuota`] === "any"}
                              onChange={(e) => {
                                  const objCopy = {...editingQuotaObj};

                                  if (e.target.checked) {
                                      objCopy[minQ] = "any";
                                  } else {
                                      objCopy[minQ] = 0;
                                  }
                                  setEditingQuotaObj(objCopy);
                              }}/>}
                                  label="Any Amount"/>

                <br/><br/>
                <TextField
                    id={`max-${z}-quota`}
                    label={`Max ${z} Quota`}
                    value={editingQuotaObj[`${z}MaxQuota`]}
                    disabled={editingQuotaObj[`${z}MaxQuota`] === "any"}
                    inputProps={{inputMode: 'numeric', pattern: '[0-9]*'}}
                    onChange={(v) => {
                        const objCopy = {...editingQuotaObj};
                        objCopy[maxQ] = parseInt(v.target.value, 10);
                        setEditingQuotaObj(objCopy);
                    }}
                />
                <Tooltip style={{"marginTop": ".25em"}}
                         title={`Maximum number of  ${z.toUpperCase()} allowed in the given time period`}>
                    <IconButton>
                        <InfoIcon/>
                    </IconButton>
                </Tooltip>
                <FormControlLabel style={{"margin": "auto"}} control={
                    <Checkbox checked={editingQuotaObj[`${z}MaxQuota`] === "any"}
                              onChange={(e) => {
                                  const objCopy = {...editingQuotaObj};

                                  if (e.target.checked) {
                                      objCopy[maxQ] = "any";
                                  } else {
                                      objCopy[maxQ] = 0;
                                  }
                                  setEditingQuotaObj(objCopy);
                              }}/>}
                                  label="Any Amount"/>

            </div>)
        }
    }

    const doesOverlap = dateRangesOverlap(quotas);
    return <>
        <Typography align="left" variant={"h5"}>
            Add Quota Constraints&nbsp;&nbsp;&nbsp;
            <IconButton aria-label="create" onClick={() => {

                props.setQuotas([...quotas, {...defaultValues}])
                // props.setSuppressions([...suppressions, ""])
            }}>
                <AddCircleIcon color={"success"}/>
            </IconButton>
        </Typography>
        {doesOverlap && <Typography color={"error"} variant={"subtitle1"} style={{}}>RANGES OVER LAP</Typography>}
        <div style={{"marginLeft": "2em"}}>
            {quotaElements}
        </div>


        <Modal
            open={editingQuotaObj != null}
            onClose={() => {
            }}
            aria-labelledby="test-modal"
            aria-describedby="test-modal-description"
            style={{"overflowY": "scroll"}}
        >

            <Box sx={{...modalStyle}}
                 style={{"maxHeight": "calc(100vh - 210px)", "overflowY": "auto"}}>
                {editingQuotaObj != null &&
                <>
                    <Typography align="left">
                        Quota Time Range (Times Are In Eastern)
                    </Typography>
                    <br/>
                    <DateTimePicker
                        renderInput={(props) => <TextField {...props} />}
                        label="Start Date/Time"
                        value={editingQuotaObj.startDate}
                        maxDateTime={editingQuotaObj.endDate}
                        onChange={(newValue) => {
                            setEditingQuotaObj({...editingQuotaObj, startDate: newValue})
                        }}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <DateTimePicker
                        renderInput={(props) => <TextField {...props} />}
                        label="End Date"
                        value={editingQuotaObj.endDate}
                        minDateTime={editingQuotaObj.startDate}
                        onChange={(newValue) => {
                            setEditingQuotaObj({...editingQuotaObj, endDate: newValue})
                        }}
                    />
                    <br/><br/>
                    {elementsForEditor}
                    <br/><br/>
                    <ButtonGroup disableElevation variant="contained" style={{"width": "100%"}}>
                        <Button size="Large" align="left" variant="contained" color="warning" onClick={() => {
                            setEditingQuotaObj(null);
                            setEditingQuotaObjIndex(null);
                        }} style={{"width": "50%"}}>
                            Cancel
                        </Button>
                        <Button size="Large" align="right" variant="contained" color="success" onClick={() => {
                            const supp = [...quotas];
                            console.log("Look here....");
                            supp[editingQuotaObjIndex] = editingQuotaObj;
                            props.setQuotas(supp)
                            setEditingQuotaObj(null);
                            setEditingQuotaObjIndex(null);
                        }} style={{"width": "50%"}}>
                            Save
                        </Button>
                    </ButtonGroup>
                </>
                }

            </Box>
        </Modal>

    </>
}


QuotaModal.propTypes = {
    quotas: PropTypes.array,
    setQuotas: PropTypes.func,
}